import { Action } from 'redux';
import { Booking } from 'types/Booking';

export const BOOKINGS_RESET = 'bookings/reset';
export const BOOKINGS_ERROR = 'bookings/error';

export const BOOKINGS_CREATE_START = 'bookings/create_start';
export const BOOKINGS_CREATE_SUCCESS = 'bookings/create_success';

export const BOOKINGS_CREATE_FOR_DEPOSIT_START = 'bookings/create_for_deposit_start';
export const BOOKINGS_CREATE_FOR_DEPOSIT_SUCCESS = 'bookings/create_for_deposit_success';

interface BookingsResetAction extends Action<typeof BOOKINGS_RESET> {}
interface BookingsErrorAction extends Action<typeof BOOKINGS_ERROR> {}

interface BookingsCreateStartAction extends Action<typeof BOOKINGS_CREATE_START> {}
interface BookingsCreateSuccessAction extends Action<typeof BOOKINGS_CREATE_SUCCESS> {
    payload: {
        booking: Booking;
    };
}

interface BookingsCreateForDepositStartAction
    extends Action<typeof BOOKINGS_CREATE_FOR_DEPOSIT_START> {}
interface BookingsCreateForDepositSuccessAction
    extends Action<typeof BOOKINGS_CREATE_FOR_DEPOSIT_SUCCESS> {
    payload: {
        booking: Booking;
    };
}

export type BookingsAction =
    | BookingsResetAction
    | BookingsErrorAction
    | BookingsCreateStartAction
    | BookingsCreateSuccessAction
    | BookingsCreateForDepositStartAction
    | BookingsCreateForDepositSuccessAction;
